import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageTransition } from '../components/PageTransition';
import { Button } from '../components/ui/Button';
import { Season2Announcement } from '../components/Season2Announcement';
import { Season2EpisodeStory } from '../components/Season2EpisodeStory';
import { latestSeason2Episode, season2Episodes } from '../data/season2Episodes';
import { SPOTIFY_SHOW_URL } from '../data/season1Episodes';
export function Season2Page() {
  return <PageTransition data-id="element-831" data-mp="sqhqtw3pbeh8">
      <div className="pt-20 min-h-screen" data-id="element-832" data-mp="spztsx97sw89">
        <Season2Announcement episode={latestSeason2Episode} showDetailsLink={false} data-id="element-833" data-mp="op67u9fc1ri0" />

        {/* Every Season 2 episode, newest first */}
        {season2Episodes.map((episode, index) => <Season2EpisodeStory key={episode.id} episode={episode} tone={index % 2 === 0 ? 'dark-700' : 'dark-800'} data-id="element-834" data-mp="eqgqchrcm92a" data-mpi={index} />)}

        {/* CTA */}
        <section className="py-20 bg-dark-700 border-t border-dark-600" data-id="element-835" data-mp="9mx3s1r3uf16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-836" data-mp="eeeulwzeyz8f">
            <div className="bg-dark-800 rounded-2xl p-8 md:p-12 text-center border border-dark-600" data-id="element-837" data-mp="egrlx0r2aly5">
              <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-838" data-mp="3vt24ltbs4kyt">
                Know someone who should be on the podcast?
              </h2>
              <p className="text-white/70 mb-8 max-w-xl mx-auto" data-id="element-839" data-mp="sfr71yfd8ipk">
                We're booking guests for Season 2 right now. Tell us their
                story.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-840" data-mp="ih1saeirnedj">
                <Link to="/guests" data-id="element-841" data-mp="nf3ayyca5boh">
                  <Button rightIcon={<ArrowRight className="w-4 h-4" data-id="element-843" data-mp="ndiev4abhkoi" />} data-id="element-842" data-mp="ne1toc4o7syb">
                    Meet Our Guests
                  </Button>
                </Link>
                <Link to="/podcasts/season-1" data-id="element-844" data-mp="385c6yput7hu5">
                  <Button variant="outline" data-id="element-845" data-mp="3875c20prxu01">Catch Up on Season 1</Button>
                </Link>
                <a href={SPOTIFY_SHOW_URL} target="_blank" rel="noopener noreferrer" data-id="element-846" data-mp="1embtxz3m6bhd">
                  <Button variant="ghost" data-id="element-847" data-mp="14wihkvvndsc2">Follow on Spotify</Button>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PageTransition>;
}